// extracted by extract-css-chunks-webpack-plugin
module.exports = {"houseIcon":"_1w4Eea"};